import { render, staticRenderFns } from "./newLottery.vue?vue&type=template&id=53993055&scoped=true&"
import script from "./newLottery.vue?vue&type=script&lang=js&"
export * from "./newLottery.vue?vue&type=script&lang=js&"
import style0 from "./newLottery.vue?vue&type=style&index=0&id=53993055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53993055",
  null
  
)

export default component.exports